<script setup lang="ts">
import { useRoute } from "vue-router";
import AuthProvider from "./auth/AuthProvider.vue";
import SidebarNav from "./components/Sidebar.vue";
import { computed } from "vue";

const route = useRoute();
const isLoginPage = computed(() => route.path === "/login");
</script>

<template>
  <AuthProvider>
    <div v-if="isLoginPage">
      <router-view />
    </div>
    <div v-else class="flex h-screen bg-dark-950 text-dark-50">
      <SidebarNav />
      <router-view />
    </div>
  </AuthProvider>
</template>
